import OrderTracker from "@iewc/Components/OrderTracker";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import React, { FC, useContext } from "react";
import { connect } from "react-redux";

const enum fields {
    heading = "heading",
    description = "description",
    statusSequence = "statusSequence",
    allProductsInLastStepLabel = "allProductsInLastStepLabel",
}

export interface StatusSequenceModel {
    fields: {
        labelSingular: string;
        labelPlural: string;
    };
}
interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.description]: string;
        [fields.statusSequence]: StatusSequenceModel[];
        [fields.allProductsInLastStepLabel]: string;
    };
}


type Props = OwnProps;

const OrderDetailsOrderTracker: FC<Props> = ({ fields }) => {
    const order = useContext(OrderStateContext) as any;
    const tracker = order?.value?.orderTracker;

    return <OrderTracker tracker={tracker} fields={fields} />
};

const widgetModule: WidgetModule = {
    component: connect(null)(OrderDetailsOrderTracker),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
        displayName: "Order tracker",
        group: "Order Details",
        fieldDefinitions: [
            {
                name: fields.heading,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Order Status",
                isRequired: false,
            },
            {
                name: fields.allProductsInLastStepLabel,
                displayName: "All products in last step label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "All lines shipped",
                isRequired: true,
            },
            {
                name: fields.description,
                displayName: "Description",
                editorTemplate: "RichTextField",
                defaultValue: "Your order may be shipped in multiple deliveries. Check statuses below.",
                fieldType: "Translatable",
                isRequired: false,
            },
            {
                name: fields.statusSequence,
                editorTemplate: "ListField",
                displayName: "Status Sequence",
                getDisplay: (item: HasFields) => item.fields.labelPlural,
                defaultValue: [],
                fieldType: "General",
                fieldDefinitions: [
                    {
                        name: "labelSingular",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        displayName: "Singular Label",
                        isRequired: true,
                    },
                    {
                        name: "labelPlural",
                        editorTemplate: "TextField",
                        defaultValue: "",
                        displayName: "Plural Label",
                        isRequired: true,
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
